<ion-menu
    (ionDidClose)="isOpen.set(false)"
    (ionWillOpen)="isOpen.set(true)"
    [contentId]="contentId()"
    [disabled]="!patient()"
    [menuId]="sidePanel.menuId"
    class="side-panel-menu"
    data-testid="patient-side-panel-w8n3c5ja"
    side="end"
    type="overlay">
    @if (isOpen() && patient()) {
        <lib-patient-side-panel-content
            (closed)="close()"
            (notesChange)="sidePanel.notesChanged()"
            (patientChange)="sidePanel.patientChanged($event)"
            (tasksChange)="sidePanel.tasksChanged()"
            (activeTabChange)="selectTab($event)"
            [activeTab]="activeTab()"
            [patient]="patient()"
            [tabs]="tabs()"></lib-patient-side-panel-content>
    }
</ion-menu>
